<template>
  <div>
    <div class="gift-menu buefy-styled-compoent">
      <div class="section__inner-bg">
          <h4 v-if='event_participation_flag' class="profile-info-item__title"><i class="fas fa-gift"></i>ハロウィン限定ギフト</h4>
          <div v-if='event_participation_flag' class="gift-list gift-list--menu">
            <template v-for="(gift, index) in eventGifts" :key="`gift-${index}`">
              <div @click="selectGift(gift)" class="gift-list-item" :class="isGiftSelected(gift) ? 'selected':''">
                <img :src="gift.image" alt="gift" class="gift-list-item__gift-icon">
                <p class="gift-list-item__title">{{ gift.title }}</p>
                <p class="gift-list-item__price">
                  <img :src="coinImage" alt="coin" class="gift-list-item__price-icon">
                  <span class="gift-list-item__price-amount">{{ gift.price }} </span>
                </p>
              </div>
            </template>
          </div>
        <h4 class="profile-info-item__title"><i class="fas fa-gift"></i>ギフト</h4>
        <div class="gift-list gift-list--menu"> 
          <template v-for="(gift, index) in gifts" :key="`gift-${index}`">
            <div @click="selectGift(gift)" class="gift-list-item" :class="isGiftSelected(gift) ? 'selected':''">
              <img :src="gift.image" alt="gift" class="gift-list-item__gift-icon">
              <p class="gift-list-item__title">{{ gift.title }}</p>
              <p class="gift-list-item__price">
                <img :src="coinImage" alt="coin" class="gift-list-item__price-icon">
                <span class="gift-list-item__price-amount">{{ gift.price }} </span>
              </p>
            </div>
          </template>
        </div>
        <div v-if='!isCurrentUser' class="gift-menu-optional-form">
          <div class="gift-menu-optional-form__anonymous-checkbox" @click="toggleIsAnonymous('partial')"> 
            <i v-if="!!isAnonymous" class="fas fa-check-square"></i>
            <i v-else class="far fa-square"></i>
            <label for="is-gift-anonymous">匿名(相手に名前を通知する)</label>
          </div>
          <div class="gift-menu-optional-form__anonymous-checkbox" @click="toggleIsAnonymous('all')"> 
            <i v-if="!!isNameAnonymous" class="fas fa-check-square"></i>
            <i v-else class="far fa-square"></i>
            <label for="is-gift-anonymous">匿名(相手に名前を通知しない)</label>
          </div>
        </div>
        <div v-if='!isCurrentUser' class="gift-menu-footer"> 
          <div v-if="!!currentUser" class="gift-menu__current-coin"> 
            <div class="gift-menu-footer__user-icon-wrapper">
                <img :src="currentUser.image" alt="user-icon" class="gift-menu-footer__user-icon">
                <img :src="coinImage" alt="coin" class="gift-menu-footer__price-icon">
            </div>
            <span>
              {{ currentUser.coin.toLocaleString() }}
            </span>
          </div>
          <div class="gift-menu__purchase-nav"> 
            <div v-if="!isDailyGiftSelected" class="gift-counter gift-counter-large">
              <span @click="handleCountChange('decrease')" role="button" class="gift-decrease-btn">
                  <i class="fas fa-minus"></i>
              </span>
              <span class="gift-counter__count">{{ count }}</span>
              <span @click="handleCountChange('increase')" role="button" class="gift-increase-btn">
                  <i class="fas fa-plus"></i>
              </span>
            </div>
            <button @click="openConfirmationModal" :class="canPurchase ? '':'disable'" class="gift-purchase-btn">
              ギフトする
            </button>
          </div>
        </div>
      </div>

      <modal v-if="showConfirmationModal" :modalSuccess="modalSuccess" @close-modal="closeModal" id="overLayGift">
        <div class="gift-confirm">
          <div class="modal-body">
            <ul class="modal-messages">
              <li class="modal-message">
                {{ this.totalAmount }}コインを消費して、{{ this.selectedUser.name }}さんに「{{this.selectedGift.title}}」を{{ this.count }}個ギフトします。よろしいでしょうか？
              </li>
            </ul>
          </div>
          <div class="modal-btns modal-btns--center-gift">
            <button @click="purchaseGift" class="modal-btn modal-btn--sucess modal-btn--single">
              OK
            </button>
          </div>
        </div>
      </modal>
      <spinner-with-overlay v-if="isLoading" />
    </div>
  </div>
</template>

<script>
import axios from 'packs/axios'
import coinImage from 'packs/assets/images/common/coin-icon.png'
import SpinnerWithOverlay from 'packs/components/utility/spinner-with-overlay.vue'

export default {
  props: ["selectedUser"],
  components: {
    SpinnerWithOverlay
  },
  data() {
    return {
      coinImage,
      currentUser: "",
      count: 1,
      isAnonymous: false,
      isNameAnonymous: false,
      gifts: [],
      eventGifts:[],
      selectedGift: "",
      isLoading: false,  
      showModal: false,
      showConfirmationModal: false,
      modalType: "",   
      modalLoading: false,
      modalSuccess: false,
      modalMessage: "",
      modalFooterHtml: "",
    };
  },
  created() {
    let self = this;
    this.fetchCurrentUser()
    this.fetchGifts();
  },
  computed: {
    totalAmount: function(){
      if(!this.selectedGift) return ""
      return this.selectedGift.price * this.count
    },
    isPurchasableDailyGift: function(){
      if(this.selectedGift.price == 10){
        return !this.selectedUser.hasPurchasedDailyGift
      }
      return true
    },
    isPurchasableDailyGiftCount: function(){
      if(this.selectedGift.price == 10){
        return this.count == 1
      }
      return true
    },
    isDailyGiftSelected: function(){
      return !!this.selectedGift && this.selectedGift.price == 10
    },
    hasEnoughCoin: function(){
      return this.currentUser.coin >= this.totalAmount;
    },
    canPurchase: function(){
      return !!this.selectedGift && this.hasEnoughCoin && this.isPurchasableDailyGift && this.isPurchasableDailyGiftCount && !this.isCurrentUser;;
    },
    isCurrentUser: function(){
      return !!this.currentUser && this.currentUser.identifiedChar == this.selectedUser.identifiedChar;
    }
  },
  methods: {
    isGiftSelected: function(gift){
      return gift.id == this.selectedGift.id;
    },
    fetchCurrentUser: function(){
      var self = this;
      axios.get("/api/v1/current_user")
      .then(function(res) {
        self.isLoading = false;
        self.currentUser = res.data.currentUser
      }).catch((err) => {   
        self.isLoading = false;                 
      })
    },
    selectGift: function(gift){
      if(this.isCurrentUser) return

      this.selectedGift = gift
      if(this.isDailyGiftSelected){
        this.count = 1
      }
      // this.showConfirmationModal();
    },
    toggleIsAnonymous: function(type){
      if(type == 'all'){
        this.isNameAnonymous = !this.isNameAnonymous
        this.isAnonymous = false
      }
      if(type == 'partial'){
        this.isAnonymous = !this.isAnonymous
        this.isNameAnonymous = false
      }
    },
    handleCountChange(type) {
      if(type == "increase"){
        if(this.count >= 20) return
        this.count ++
      }
      if(type == "decrease"){
        if(this.count <= 1) return
        this.count --
      }
    },
    purchaseGift(){
      this.closeModal();
      var self = this;      
      if(!this.hasEnoughCoin){
        this.showErrorModal("購入に必要なコインが足りていません。")
        this.modalFooterHtml = '<div class="modal-footer"><a href="/coin/market" class="modal-btn modal-btn--alert modal-btn--single">コインを購入</a></div>'
        return
      }
    
      if(!this.selectedGift){
        this.showErrorModal("ギフトを選択して下さい")
        return
      }

      if(!this.isPurchasableDailyGiftCount){
        this.showErrorModal("このギフトは１度に1個のみ送れます")
        return
      }

      if(!this.isPurchasableDailyGift){
        this.showErrorModal("このギフトは同じユーザーに1日1個のみ送れます。また翌日お試しください")
        return
      }

      if(!this.canPurchase){
        this.showErrorModal("無効なリクエストです")
        return
      }
      let params = {
        gift_purchase: {gift_id: this.selectedGift.id, total_amount: this.totalAmount, count: this.count, user_identified_char: this.selectedUser.identifiedChar, is_anonymous: this.isAnonymous || this.isNameAnonymous, is_name_anonymous: this.isNameAnonymous}
        
      }

      
      self.isLoading = true;
      axios.post(`/api/v1/gift_purchases`, params)
      .then(function(res) {
        if(res.data.success){
          alert(res.data.message)
          location.href="/chat"
        } else {
          alert(res.data.message)
          location.href="/chat"
        }
      }).catch((err) => {              
      })
    },
    fetchGifts: function(){
      var self = this;
      axios.get(`/api/v1/gifts`, { params: { user_identified_char: this.selectedUser.identifiedChar }})
      .then(function(res) {
        self.gifts = res.data.gifts
        self.eventGifts = res.data.event_gifts
        self.event_participation_flag = res.data.event_participation_flag
        self.isLoading = false;
      }).catch((err) => {   
        console.log(err)
        self.isLoading = false;                 
      })
    },
    openConfirmationModal(){
      if(this.currentUser.confirmed_at === null){
        window.location.href = '/users/done_temporary_registration?'+'gift';
        return
      }

      if(!this.hasEnoughCoin){
        this.showErrorModal("購入に必要なコインが足りていません")
        this.modalFooterHtml = '<div class="modal-footer"><a href="/coin/market" class="modal-btn modal-btn--alert modal-btn--single">コインを購入</a></div>'
        return
      }
    
      if(!this.selectedGift){
        this.showErrorModal("ギフトを選択して下さい")
        return
      }

      if(!this.isPurchasableDailyGiftCount){
        this.showErrorModal("このギフトは１度に1個のみ送れます")
        return
      }

      if(!this.isPurchasableDailyGift){
        this.showErrorModal("このギフトは同じユーザーに1日1個のみ送れます。また翌日お試しください")
        return
      }
      this.showConfirmationModal = true;
      this.modalType = "normal";
      this.modalSuccess = false;
    },
    closeModal: function() {
      if(this.modalSuccess === true){
        location.href = window.location.href + "?event=gift_purchase"
        return
      }
      this.modalFooterHtml = ""
      this.showConfirmationModal = false;
      this.showModal = false;
    },
    showErrorModal(msg){
      this.showModal = true;
      this.modalType = "normal";
      this.modalSuccess = false;
      this.modalMessage = msg;
    },
  }
}
</script>

<style scoped lang="scss">
  .gift-purchase-agreement{
    li{
      display: flex;
      input{
        margin-right: 4px;
        margin-top: 4px;
      }
    }
  }
  #overLayGift{
    /*　要素を重ねた時の順番　*/
    z-index:1;
    /*　画面全体を覆う設定　*/
    position:fixed;
    top:0;
    left:0;
    width:100%;
    height:100%;
    background-color:rgba(0,0,0,0.5);
    /*　画面の中央に要素を表示させる設定　*/
  }
  .modal-btns--center-gift{
    text-align: center;
    transform: translateY(-18px);
  }
  .gift-confirm{
    background-color: white;
    margin: 20%;
    border-radius: 8px;
  }
</style>
